import { O as OramaFacets$1, d as defineCustomElement$1 } from './p-0d0c9ef8.js';
const OramaFacets = OramaFacets$1;
const defineCustomElement = defineCustomElement$1;
export { OramaFacets, defineCustomElement }; //# sourceMappingURL=orama-facets.js.map
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JhbWEtZmFjZXRzLmpzIiwic291cmNlcyI6W10sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiIifQ==